<template>
  <vue-apex-charts
    ref="vuelinecomercial"
    class="lineComercial"
    type="line"
    :series="series"
    :options="chartOptions"
    :height="height"
    :width="'100%'"
  />
</template>

  <style lang="scss">
  .lineComercial .apexcharts-tooltip {
    color: rgb(0, 0, 0);
    font-family: inherit;
    font-weight: 400;
  }
  </style>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'LineChartComercial',
  components: {
    VueApexCharts,
  },
  props: {
    id: {
      type: Number,
      default: 0,
    },
    dados: {
      type: Object,
      required: true,
    },
    height: {
      type: String,
      default: '182',
    },
  },
  data() {
    return {
      series: [
        {
          name: this.dados.nomes[0],
          data: this.dados.quantidadeAprovadas,
          numero: this.dados.valoresAprovada,
        },
        {
          name: this.dados.nomes[2],
          data: this.dados.quantidadeRejeitadas,
          numero: this.dados.valoresRejeitada,
        },
        {
          name: this.dados.nomes[1],
          data: this.dados.quantidadeExpiradas,
          numero: this.dados.valoresExpirada,
        },
      ],
      chartOptions: {
        chart: {
          zoom: {
            enabled: false,
          },
          height: this.height,
          type: 'line',
          dropShadow: {
            enabled: true,
            color: '#000',
            top: 18,
            left: 7,
            blur: 10,
            opacity: 0.2,
          },
          toolbar: {
            show: false,
          },
        },
        tooltip: {
          enabled: true,
          enabledOnSeries: undefined,
          shared: false,
          followCursor: false,
          fillSeriesColor: false,
          theme: 'light',
          style: {
            fontSize: '14px',
            fontFamily: undefined,
          },
          onDatasetHover: {
            highlightDataSeries: true,
          },
          x: {
            show: true,
            format: 'dd MMM',
            formatter: undefined,
          },
          y: {
            formatter(value, {
              seriesIndex, dataPointIndex, w,
            }) {
              return `<b> ${w.globals.initialSeries[seriesIndex].name}</b> <br> 
               Quantidade: ${w.globals.initialSeries[seriesIndex].data[dataPointIndex]}<br> 
              Valor: ${w.globals.initialSeries[seriesIndex].numero[dataPointIndex].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}`
            },
            title: {
              formatter: () => '',
            },
          },
          marker: {
            show: true,
          },
          items: {
            display: 'flex',
          },
          fixed: {
            enabled: true,
            position: 'topRight',
            offsetX: 0,
            offsetY: 0,
          },
        },
        colors: this.dados.cores,
        dataLabels: {
          enabled: true,
        },
        stroke: {
          curve: 'smooth',
        },
        grid: {
          borderColor: '#e7e7e7',
          row: {
            colors: ['#f3f3f3', 'transparent'],
            opacity: 0.5,
          },
        },
        markers: {
          size: 1,
        },
        xaxis: {
          categories: this.dados.competencias,
        },
        yaxis: {
          labels: {
            style: {
              colors: [],
              fontSize: '12px',
              fontFamily: 'Helvetica, Arial, sans-serif',
              fontWeight: 400,
            },
          },
        },
        legend: {
          position: 'bottom',
          horizontalAlign: 'center',
          fontSize: '14px',
          fontFamily: 'Helvetica, Arial',
        },
      },
    }
  },
}

</script>
